import React, {Fragment} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Alert, DropdownItem} from 'reactstrap';
import {ClassroomIndividualAPI, ClassRoomInsideAPI, LeadLogAPI} from "api";

class DeleteClassroomIndividualLesson extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    showModal() {
        const self = this;
        global.SweetAlert.fire({
            title: "Elimina lezione",
            // Il testo precedente ("Perderai le presenze dei corsisti") era copiato dalle classi di
            // gruppo e per le individuali non e' mai stato vero: le presenze li' non esistevano.
            // Oggi esistono, ma proprio per questo il server RIFIUTA di cancellare una lezione a cui
            // il corsista ha partecipato: non c'e' piu' niente da perdere, c'e' da sapere quando si
            // puo' fare.
            text: 'Vuoi davvero eliminare la lezione? Si possono eliminare solo le lezioni future a cui il corsista non è ancora entrato.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si, elimina',
            cancelButtonText: 'Annulla',
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-outline-danger ms-1'
            },
            buttonsStyling: false,
            showLoaderOnConfirm: true,
            preConfirm: function() {
                return new Promise(function(resolve, reject) {
                    ClassroomIndividualAPI.deleteLessonIndividual(self.props.id).then(() => {
                        resolve();
                    }).catch((errore) => {
                        // INVALID_LESSON copre due casi che al docente sembrano lo stesso: lezione
                        // gia' frequentata, oppure ormai passata. Meglio spiegarli che lasciare il
                        // messaggio generico, che farebbe pensare a un guasto.
                        let messaggio = 'Si è verificato un errore durante la cancellazione della lezione.';
                        if (errore && errore.status === "INVALID_LESSON")
                            messaggio = 'Questa lezione non si può eliminare: il corsista vi è già entrato, oppure si è già svolta. Le lezioni svolte restano nello storico delle presenze.';

                        global.SweetAlert.fire({
                            icon: 'error',
                            title: 'Non è stato possibile eliminare',
                            text: messaggio,
                            customClass: {
                                confirmButton: 'btn btn-success'
                            }
                        });
                        reject()
                    })
                });
            },
        }).then(function (result) {
            if (result.value) {
                global.SweetAlert.fire({
                    icon: 'success',
                    title: 'Lezione eliminata!',
                    text: 'Lezione eliminata correttamente.',
                    customClass: {
                        confirmButton: 'btn btn-success'
                    }
                });
                self.props.onResolve();
            }
        })
    }


    render() {
        return (
            <React.Fragment>
                <li className="list-inline-item cursor-pointer" onClick={() => this.showModal()}>
                    <i className="ri-delete-bin-5-fill fs-20 text-danger"></i>
                </li>
            </React.Fragment>
        )
    }
}

export default DeleteClassroomIndividualLesson;
